export default __webpack_public_path__ + "static/media/freya-node-silver.fa691117.svg";